import { getWithdrawalRequestStatusText, ListWithdrawal } from '@mybonus/public';
import type { Theme } from '@mybonus/ui';
import { useTheme } from 'styled-components';

import { Wrapper, Description, Amount } from './ListItem.parts';

export type ListItemProps = {
	item: ListWithdrawal;
};

function getColor(theme: Theme, status: ListWithdrawal['status']) {
	switch (status) {
		case 'IN_REVIEW':
			return theme.color.orange.base;
		case 'PENDING':
			return theme.color.green.base;
		case 'REVIEW_DENIED':
			return theme.color.red.base;
		case 'WITHDRAWN':
		default:
			return theme.color.darkGray.base;
	}
}

export function ListItem(props: ListItemProps) {
	const { status } = props.item;

	const theme = useTheme() as Theme;
	const clr = getColor(theme, status);

	return (
		<Wrapper>
			<Description color={clr}>
				{props.item.createdAt.toISOString().split('T')[0]} {getWithdrawalRequestStatusText(status)}
			</Description>
			<Amount color={clr}>{props.item.amount}</Amount>
		</Wrapper>
	);
}
